<template>
    <!-- 转派待办弹窗 -->
    <el-dialog
        title="转派待办"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        append-to-body
        width="520px"
        @close="close"
    >
        <div class="reassign-content" v-loading="detailLoading">
            <!-- 待办标题 -->
            <div class="task-name">
                <span class="label">待办标题：</span>
                <span>{{ taskTitle }}</span>
            </div>
            <!-- 当前处理人 -->
            <div class="current-assignees MT10">
                <span class="label">当前处理人：</span>
                <el-tag
                    v-for="item in currentAssignees"
                    :key="item.assigneeId"
                    :type="item.assigneeStatus == 2 ? 'success' : 'info'"
                    size="small"
                    class="MR5"
                >{{ item.assigneeName }}</el-tag>
                <span v-if="!currentAssignees.length">无</span>
            </div>
            <!-- 转派表单 -->
            <el-form :model="formData" :rules="rules" ref="formRef" class="MT20">
                <!-- 新处理人 -->
                <el-form-item label="新处理人：" prop="newAssigneeIds">
                    <el-select
                        v-model="formData.newAssigneeIds"
                        filterable
                        remote
                        multiple
                        placeholder="请选择新处理人"
                        :remote-method="searchUser"
                        @focus="searchUser('')"
                        :loading="userLoading"
                        style="width: 100%;"
                    >
                        <el-option
                            v-for="item in userList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            :disabled="currentAssignees.find(v => v.assigneeId == item.id) ? true : false"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <!-- 保留原处理人：勾选=追加处理人，不勾选=替换处理人（PRD 6.6） -->
                <el-form-item>
                    <el-checkbox v-model="formData.keepOriginalAssignee">保留原处理人</el-checkbox>
                    <span class="keep-tips color-info">{{ formData.keepOriginalAssignee ? '勾选后原处理人与新处理人共同处理该待办' : '不勾选则替换为新处理人，原处理人不再处理该待办' }}</span>
                </el-form-item>
                <!-- 转派说明 -->
                <el-form-item label="转派说明：">
                    <el-input
                        type="textarea"
                        v-model.trim="formData.remark"
                        placeholder="请输入转派说明（选填）"
                        maxlength="500"
                        show-word-limit
                        :rows="4"
                    ></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" :loading="btnLoading" @click="submit">确认转派</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'Reassign',
    data() {
        return {
            dialogVisible: false, // 弹窗显示状态
            detailLoading: false, // 详情加载状态
            btnLoading: false, // 提交按钮加载状态
            userLoading: false, // 用户搜索加载状态
            taskId: '', // 待办ID
            taskTitle: '', // 待办标题
            currentAssignees: [], // 当前处理人列表
            userList: [], // 用户搜索列表
            formData: {
                newAssigneeIds: [], // 新处理人ID列表
                keepOriginalAssignee: false, // 是否保留原处理人：true-追加处理人，false-替换处理人
                remark: '', // 转派说明
            },
            rules: {
                newAssigneeIds: [
                    { required: true, message: '请选择新处理人', trigger: 'change' },
                ],
            },
        };
    },
    methods: {
        // 关闭弹窗
        close() {
            this.dialogVisible = false;
            this.taskId = '';
            this.taskTitle = '';
            this.currentAssignees = [];
            this.formData.newAssigneeIds = [];
            this.formData.keepOriginalAssignee = false;
            this.formData.remark = '';
        },
        // 打开转派弹窗
        async open(id) {
            this.taskId = id || '';
            this.dialogVisible = true;
            this.detailLoading = true;
            try {
                const res = await this.$request({
                    url: '/pendingtask/detail',
                    method: 'post',
                    data: { pendingTaskId: this.taskId },
                });
                const { state, result } = res.data;
                if (state == 1 && result && result.taskInfo) {
                    this.taskTitle = result.taskInfo.title || '';
                    this.currentAssignees = result.taskInfo.assignees || [];
                }
            } catch (err) {
                this.$message.error('获取待办详情失败');
            } finally {
                this.detailLoading = false;
            }
        },
        // 读取最近选择过的处理人（需求7139979129）
        getRecentAssignees() {
            try {
                return JSON.parse(localStorage.getItem('recentAssigneeOptions') || '[]');
            } catch (err) {
                return [];
            }
        },
        // 记录最近选择过的处理人（最新在前，最多保留20个）
        saveRecentAssignees(users) {
            if (!users || !users.length) return;
            const recent = this.getRecentAssignees().filter(v => !users.some(u => u.id === v.id));
            localStorage.setItem('recentAssigneeOptions', JSON.stringify([...users, ...recent].slice(0, 20)));
        },
        // 搜索用户
        async searchUser(query) {
            if( !query && this.userList.length ){
                return;
            }
            this.userLoading = true;
            try {
                const res = await this.$request({
                    url: '/adminUser/list',
                    method: 'post',
                    params: { keyword: query },
                });
                const { state, result } = res.data;
                if (state == 1 && result) {
                    if (!query) {
                        this.userList = this.userList.concat([...result]);
                    } else {
                        this.userList = result;
                    }
                    // 去重
                    this.userList = this.userList.filter((item, index, self) =>
                        index === self.findIndex(t => t.id === item.id)
                    );
                    // 需求7139979129：最近选择过的处理人排在前面
                    const recentIds = this.getRecentAssignees().map(v => v.id);
                    if (recentIds.length) {
                        this.userList.sort((a, b) => {
                            const ai = recentIds.indexOf(a.id);
                            const bi = recentIds.indexOf(b.id);
                            return (ai === -1 ? recentIds.length : ai) - (bi === -1 ? recentIds.length : bi);
                        });
                    }
                }
            } catch (err) {
                this.$message.error('搜索用户失败');
            } finally {
                this.userLoading = false;
            }
        },
        // 提交转派
        async submit() {
            try {
                await this.$refs.formRef.validate();
            } catch {
                return;
            }
            this.btnLoading = true;
            try {
                //勾选保留原处理人时，新处理人在前、原处理人追加在后（前端拼接语义，后端统一替换）
                const submitAssigneeIds = this.formData.keepOriginalAssignee
                    ? [...new Set([...this.formData.newAssigneeIds, ...this.currentAssignees.map(v => v.assigneeId)])]
                    : [...this.formData.newAssigneeIds];
                const res = await this.$request({
                    url: '/pendingtask/reassign',
                    method: 'post',
                    data: {
                        newAssigneeIds: submitAssigneeIds,
                        pendingTaskId: this.taskId,
                        remark: this.formData.remark,
                    },
                });
                const { state, msg } = res.data;
                if (state == 1) {
                    this.$message.success('转派成功');
                    // 需求7139979129：记录最近选择的新处理人
                    this.saveRecentAssignees(this.formData.newAssigneeIds.map(id => {
                        const user = this.userList.find(u => u.id == id);
                        return user ? { id: user.id, name: user.name } : null;
                    }).filter(Boolean));
                    this.close();
                    this.$emit('onSuccess');
                } else {
                    this.$message.error(msg || '转派失败');
                }
            } catch (err) {
                this.$message.error('转派失败');
            } finally {
                this.btnLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
// 表单标签加粗
.label {
    font-weight: bold;
}

// 保留原处理人提示文案
.keep-tips {
    font-size: 12px;
    margin-left: 10px;
}
</style>